import type { AnnualCashFlowArrayType } from '../BusinessContactForm.types';

export const mapRadioGroupConfigData = (data: AnnualCashFlowArrayType) =>
    data.map(text => ({
        children: text,
        value: text,
    }));
